export const DESCRIPTION_MAX_LENGTH: number = 255;
export const NAME_MAX_LENGTH: number = 80;